import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  ThirdTitle,
} from "../ContentsStyles";

const CG_11 = () => {
  return (
    <>
      <Parah>
        Copyright is a legal right that protects original works of authorship
        (e.g., music, videos) and original expression of an idea (e.g., the
        specific way a video or music is expressed or created), although it does
        not protect underlying ideas or facts. A trademark is a word, symbol,
        slogan, or design that identifies and distinguishes the source of a
        product or service. We encourage everyone to create and share original
        content. Content that infringes someone else's intellectual property
        rights is prohibited on our platform and will be removed if we become
        aware of it. The use of copyrighted work under certain circumstances,
        such as the fair use doctrine or other applicable laws, or the use of a
        trademark to reference, lawfully comment, criticize, parody, make a fan
        page, or review a product or service, may not be considered a violation
        of our policies.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that violates or infringes someone else's copyrights,
        trademarks, or other intellectual property rights
      </PointsWrapper>
    </>
  );
};

export default CG_11;
